export const bundleManifest = () => window.OFFOLIO_BUNDLE_MANIFEST || null;

export const portfolioContextResource = () => bundleManifest() ? 'workspace-context' : 'portfolio';

export function bundleFeatureEnabled(feature) {
  const manifest = bundleManifest();
  return !manifest || (manifest.schemaVersion === 1 && manifest.features?.[feature] === true);
}

export function bundleRouteAvailable(pathname) {
  const manifest = bundleManifest();
  if (!manifest) return true;
  if (manifest.schemaVersion !== 1 || !Array.isArray(manifest.routes)) return false;
  const rule = manifest.routes.find(({ pattern }) => new RegExp(pattern).test(pathname));
  return rule ? bundleFeatureEnabled(rule.feature)
    : (manifest.infrastructureRoutes || []).some(pattern => new RegExp(pattern).test(pathname));
}

export function bundleLicenceAvailable(licence) {
  const manifest = bundleManifest();
  if (!manifest) return true;
  if (licence === 'Hide Portfolio') return !bundleFeatureEnabled('portfolio');
  const feature = manifest.licences?.[licence];
  return Boolean(feature && bundleFeatureEnabled(feature));
}

export function logBundleStartup() {
  const manifest = bundleManifest();
  if (manifest) console.info('OFFOLIO bundle', manifest.bundleTag, 'manifest', manifest.version);
}
